<article class="dialog">
  <button class="dialog__close" (click)="dismiss()">
    <svg-icon
      key="times"
      [fontSize]="'2rem'"
    ></svg-icon>
  </button>

  <header class="dialog__header">
    <h1>{{ 'sharePanel.errors.server_error_title' | transloco }}</h1>
    <p>{{ 'sharePanel.errors.server_error_body_code' | transloco }}</p>
  </header>

  <footer class="dialog__footer">
    <aero-button
      (click)="dismiss()"
      label="{{ 'sharePanel.errors.button' | transloco }}"
    >
    </aero-button>
  </footer>
</article>
